'use strict';
console.clear();

var home = document.querySelector('.home');
var label = document.querySelector('.label');
var artist = document.querySelector('.artist');


if (home) {
  // HEIGHT
  var height = window.innerHeight;
  document.documentElement.style.setProperty('--screen-height', height + 'px');

  window.addEventListener('resize', function () {
    var height = window.innerHeight;
    document.documentElement.style.setProperty('--screen-height', height + 'px');
  });


  // LOADER
  const progressBar = document.getElementById("progressBar");
  const counter = document.getElementById("counter");
  const loader = document.getElementById("loader");

  const maxCount = 140;
  let progress = 0;

  const loaderShownKey = "loaderShown";

  if (!sessionStorage.getItem(loaderShownKey)) {
    function updateLoader() {
      progress++;
      const progressPercentage = (progress / maxCount) * 100;
      progressBar.style.width = `${progressPercentage}%`;
      counter.textContent = `${progress}/${maxCount} BPM`;

      if (progress < maxCount) {
        requestAnimationFrame(updateLoader);
      } else {
        setTimeout(() => {
          loader.style.display = "none";
          sessionStorage.setItem(loaderShownKey, "true");
        }, 500);
      }
    }

    requestAnimationFrame(updateLoader);
  } else {
    loader.style.display = "none";
  }


  // APPARITION SECTION
  const slides = document.querySelectorAll('.slider__el');
  const buttons = document.querySelectorAll('.slider__button');
  let currentIndex = 0; 
  let isTransitioning = false; 

  const changeSlide = (direction) => {
    if (isTransitioning) return; 
    
    isTransitioning = true; 

    slides[currentIndex].classList.remove('slider__el--active');
    buttons[currentIndex].classList.remove('slider__button--active');

    currentIndex = (direction === 1) ? Math.min(currentIndex + 1, slides.length - 1) : Math.max(currentIndex - 1, 0);

    slides[currentIndex].classList.add('slider__el--active');
    buttons[currentIndex].classList.add('slider__button--active');

    setTimeout(() => {
      isTransitioning = false;
    }, 1000); 
  };

  window.addEventListener('wheel', (event) => {
    if (isTransitioning) return; 

    if (event.deltaY > 0) {
      changeSlide(1); 
    } else {
      changeSlide(-1); 
    }
  });

  let touchStart = 0;

  window.addEventListener('touchstart', (e) => {
    touchStart = e.changedTouches[0].clientY;
  });

  window.addEventListener('touchend', (e) => {
    const touchEnd = e.changedTouches[0].clientY;

    if (touchEnd > touchStart) {
      changeSlide(-1); 
    } else if (touchEnd < touchStart) {
      changeSlide(1); 
    }
  });

  const showSection = (index) => {
    if (isTransitioning) return; 

    isTransitioning = true; 

    slides.forEach(section => section.classList.remove('slider__el--active'));
    buttons.forEach(button => button.classList.remove('slider__button--active'));

    currentIndex = index;
    slides[currentIndex].classList.add('slider__el--active');
    buttons[currentIndex].classList.add('slider__button--active');

    setTimeout(() => {
      isTransitioning = false;
    }, 1000); 
  };

  buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
      showSection(index);
    });
  });


  // LANCEMENT MUSIQUE INDEX
  const musicButtons = document.querySelectorAll(".listeTableau__button");
  const audioPlayer = document.getElementById("audio-player");
  audioPlayer.volume = 0.4;

  function toggleMusic(button) {
    const src = button.dataset.src;
    const isActive = button.classList.contains("listeTableau__button--active");

    if (isActive) {
      audioPlayer.pause();
      button.classList.remove("listeTableau__button--active");
      const listItem = button.closest(".listeTableau__el");
      listItem.classList.remove("listeTableau__el--active");
      const speaker = listItem.querySelector(".listeTableau__speakers");
      if (speaker) {
        speaker.classList.remove("listeTableau__speakers--active");
      }
    } else {
      audioPlayer.src = src;
      audioPlayer.play().catch(error => {
        console.error("La lecture a échoué : ", error);
      });

      musicButtons.forEach(btn => {
        btn.classList.remove("listeTableau__button--active");
        btn.closest(".listeTableau__el").classList.remove("listeTableau__el--active");
        const speaker = btn.closest(".listeTableau__el").querySelector(".listeTableau__speakers");
        if (speaker) {
          speaker.classList.remove("listeTableau__speakers--active");
        }
      });

      button.classList.add("listeTableau__button--active");
      const listItem = button.closest(".listeTableau__el");
      listItem.classList.add("listeTableau__el--active");
      const speaker = listItem.querySelector(".listeTableau__speakers");
      if (speaker) {
        speaker.classList.add("listeTableau__speakers--active");
      }
    }
  }

  musicButtons.forEach(button => {
    button.addEventListener("click", () => {
      toggleMusic(button);
    });
  });

  audioPlayer.addEventListener("ended", () => {
    const activeButton = document.querySelector(".listeTableau__button--active");
    let nextButton;

    if (activeButton) {
      const currentIndex = Array.from(musicButtons).indexOf(activeButton);
      nextButton = musicButtons[(currentIndex + 1) % musicButtons.length];
    } else {
      nextButton = musicButtons[0];
    }

    if (nextButton) {
      toggleMusic(nextButton);
    }
  });
}
else if(artist){
  const player = document.getElementById('audio-player');
  const progressElement = document.querySelector('.release__progress');
  const musicButtons = document.querySelectorAll('.listeTableau__button');
  const playPauseButton = document.querySelector('.release__button--play');
  const nextButton = document.querySelector('.release__button--next');
  const pastButton = document.querySelector('.release__button--past');
  const releaseElements = document.querySelectorAll('.release__el');

  player.volume = 0.4; 

  function updateProgress() {
    const percentage = (player.currentTime / player.duration) * 100;
    progressElement.style.width = percentage + '%';
  }

  function toggleMusic(button) {
    const src = button.dataset.src;
    const isActive = button.classList.contains('listeTableau__button--active');

    if (isActive && !player.paused) {
      player.pause();
      updatePlayPauseButton(); 
    } else {
      resetActiveClasses();

      if (player.src !== src) {
        player.src = src;
      }
      player.play().catch(error => {
        console.error('La lecture a échoué : ', error);
      });

      button.classList.add('listeTableau__button--active');
      button.closest('.listeTableau__el').classList.add('listeTableau__el--active');

      const index = Array.from(musicButtons).indexOf(button);
      releaseElements[index].classList.add('release__el--active');

      const speaker = button.closest('.listeTableau__el').querySelector('.listeTableau__speakers');
      if (speaker) {
        speaker.classList.add('listeTableau__speakers--active');
      }

      updatePlayPauseButton();
    }
  }

  function resetActiveClasses() {
    const allSpeakers = document.querySelectorAll('.listeTableau__speakers');
    allSpeakers.forEach(speaker => {
      speaker.classList.remove('listeTableau__speakers--active');
    });

    musicButtons.forEach(btn => {
      btn.classList.remove('listeTableau__button--active');
      btn.closest('.listeTableau__el').classList.remove('listeTableau__el--active');
    });

    releaseElements.forEach(el => {
      el.classList.remove('release__el--active');
    });
  }

  function updatePlayPauseButton() {
    if (player.paused) {
      playPauseButton.style.backgroundImage = "url('assets/svg/play.svg')";
    } else {
      playPauseButton.style.backgroundImage = "url('assets/svg/pause.svg')";
    }
  }

  function togglePlayPause() {
    const activeButton = document.querySelector('.listeTableau__button--active');

    if (player.paused) {
      if (!activeButton) {
        toggleMusic(musicButtons[0]); 
      } else {
        player.play();
        updatePlayPauseButton(); 
      }
    } else {
      player.pause();
      updatePlayPauseButton(); 
    }
  }

  function playNext() {
    const activeButton = document.querySelector('.listeTableau__button--active');
    let nextButtonElement;

    if (activeButton) {
      const currentIndex = Array.from(musicButtons).indexOf(activeButton);
      nextButtonElement = musicButtons[(currentIndex + 1) % musicButtons.length];
    } else {
      nextButtonElement = musicButtons[0];
    }

    toggleMusic(nextButtonElement);
  }

  function playPrevious() {
    const activeButton = document.querySelector('.listeTableau__button--active');
    let previousButtonElement;

    if (activeButton) {
      const currentIndex = Array.from(musicButtons).indexOf(activeButton);
      previousButtonElement = musicButtons[(currentIndex - 1 + musicButtons.length) % musicButtons.length];
    } else {
      previousButtonElement = musicButtons[musicButtons.length - 1];
    }

    toggleMusic(previousButtonElement);
  }

  playPauseButton.addEventListener('click', togglePlayPause);
  nextButton.addEventListener('click', playNext);
  pastButton.addEventListener('click', playPrevious);

  musicButtons.forEach(button => {
    button.addEventListener('click', () => {
      toggleMusic(button);
    });
  });

  player.addEventListener('ended', playNext);

  player.addEventListener('timeupdate', updateProgress);
}
else if (label){
  let currentAudio = null; 
  let currentIndex = -1; 

  const svgs = document.querySelectorAll('.labels__SVG');
  const items = document.querySelectorAll('.labels__el');
  const audio = document.querySelector('.audio-player');

  audio.volume = 0.4; 

  function playAudio(index) {
    const newAudio = document.getElementById(`audio${index + 1}`);

    if (currentIndex === index) {
      if (currentAudio) {
        currentAudio.pause();
        currentAudio.currentTime = 0;
        currentAudio = null;
        currentIndex = -1;
        return;
      }
    }

    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
    }

    if (newAudio) {
      newAudio.currentTime = 0;
      newAudio.play();
      currentAudio = newAudio;
      currentIndex = index;

      currentAudio.onended = () => {
        const nextIndex = (currentIndex + 1) % document.querySelectorAll('.labels__line').length;
        showItem(nextIndex);
      };
    }
  }

  function showItem(index) {
    items.forEach((item, i) => {
      item.classList.toggle('labels__el--active', i === index);
    });

    document.querySelectorAll('.labels__line').forEach(bar => {
      bar.classList.remove('labels__line--active');
    });

    svgs.forEach(svg => {
      const bars = svg.querySelectorAll('.labels__line');
      if (bars[index]) {
        bars[index].classList.add('labels__line--active');
      }
    });

    playAudio(index);
  }

  svgs.forEach(svg => {
    const bars = svg.querySelectorAll('.labels__line');

    bars.forEach((bar, i) => {
      bar.addEventListener('click', () => {
        showItem(i);
      });
    });
  });
}  


//BURGER MENU
const navButton = document.querySelector('.nav__button');
const navList = document.querySelector('.nav__list');
const footer = document.querySelector('.footer');

navButton.addEventListener('click', () => {
  navButton.classList.toggle('nav__button--active');
  navList.classList.toggle('nav__list--active');
  footer.classList.toggle('footer--active');
  
  if (navButton.classList.contains('nav__button--active')) {
    navButton.textContent = 'Close';
  } else {
    navButton.textContent = 'Menu';
  }
});


//GRILLE
document.querySelectorAll('.square').forEach(square => {
  square.addEventListener('mouseover', () => {
    square.classList.add('square--active');
    setTimeout(() => {
        square.classList.remove('square--active');
      }, 1500);
    });
});


//TRANSITION
const transitionContainer = document.querySelector('.transition-container');
const links = document.querySelectorAll('.nav__link');

function createPixels() {
    transitionContainer.innerHTML = '';

    const screenArea = window.innerWidth * window.innerHeight;
    const squareSize = Math.sqrt(screenArea / 1000) * 4; 
    const cols = Math.ceil(window.innerWidth / squareSize);
    const rows = Math.ceil(window.innerHeight / squareSize);
    const totalPixels = cols * rows;

    transitionContainer.style.gridTemplateColumns = `repeat(${cols}, ${squareSize}px)`;
    transitionContainer.style.gridTemplateRows = `repeat(${rows}, ${squareSize}px)`;

    for (let i = 0; i < totalPixels; i++) {
        const pixel = document.createElement('div');
        pixel.classList.add('pixel');
        transitionContainer.appendChild(pixel);
    }
}

function startTransition(destinationUrl) {
    const pixels = Array.from(document.querySelectorAll('.pixel'));
    const shuffledPixels = pixels.sort(() => Math.random() - 0.5);

    const totalDuration = 750; 
    const delayPerPixel = totalDuration / shuffledPixels.length; 

    shuffledPixels.forEach((pixel, index) => {
        setTimeout(() => {
            pixel.style.opacity = 1;
        }, index * delayPerPixel);
    });

    setTimeout(() => {
        window.location.href = destinationUrl;
    }, totalDuration);
}

function endTransition() {
    const pixels = Array.from(document.querySelectorAll('.pixel'));
    const shuffledPixels = pixels.sort(() => Math.random() - 0.5);

    const totalDuration = 750; 
    const delayPerPixel = totalDuration / shuffledPixels.length; 

    shuffledPixels.forEach((pixel, index) => {
        setTimeout(() => {
            pixel.style.opacity = 0;
        }, index * delayPerPixel);
    });
}

links.forEach(link => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        const destinationUrl = link.href;
        startTransition(destinationUrl);
    });
});

createPixels();

window.addEventListener('load', endTransition);


// SCROLL
document.addEventListener('wheel', function (event) {
  if ((event.deltaY < 0 && window.scrollY <= 0) || 
      (event.deltaY > 0 && window.scrollY + window.innerHeight >= document.documentElement.scrollHeight)) { 
      event.preventDefault();
  }
}, { passive: false });


